export type ParsedAdRelationship = {
  direction: string;
  relationshipType: string;
  isAbusable: boolean;
  peerDisplayName: string;
  peerEntityKind?: string;
  peerNodeId: string;
};

export type ParsedAdRelationshipsOutput = {
  centerNodeId?: string;
  relationships: ParsedAdRelationship[];
  total?: number;
};

const RELATIONSHIP_LINE_PATTERN =
  /^-\s+\[([^\]]+)\]\s+(\S+)(?:\s+\(abusable\))?\s+->\s+(.+?)(?:\s+\(([^)]+)\))?\s+\|\s+peer:\s+(\S+)$/;

export function parseAdRelationshipsOutput(
  output: string,
): ParsedAdRelationshipsOutput | null {
  const lines = output.split('\n').map((line) => line.trim());
  const headerMatch = lines[0]?.match(
    /^Showing\s+(\d+)\s+of\s+(\d+)\s+relationships\s+for\s+(\S+):/i,
  );
  const relationships: ParsedAdRelationship[] = [];

  for (const line of lines) {
    const match = line.match(RELATIONSHIP_LINE_PATTERN);
    if (!match) {
      continue;
    }

    relationships.push({
      direction: match[1],
      relationshipType: match[2],
      isAbusable: line.includes('(abusable)'),
      peerDisplayName: match[3].trim(),
      peerEntityKind: match[4],
      peerNodeId: match[5],
    });
  }

  if (relationships.length === 0 && !headerMatch) {
    return null;
  }

  return {
    centerNodeId: headerMatch?.[3],
    total: headerMatch ? Number(headerMatch[2]) : undefined,
    relationships,
  };
}
